export var TAB_CLASS_PREFIX = 'Tab';